import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const styles = [{
  name: 'Classic Shaker',
  finish: 'Espresso Wood',
  image: 'https://images.unsplash.com/photo-1588854337236-6889d631faa8?auto=format&fit=crop&q=80&w=800'
}, {
  name: 'Modern Slab',
  finish: 'Matte Charcoal',
  image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&q=80&w=800'
}, {
  name: 'Raised Panel',
  finish: 'Copper Brown',
  image: 'https://cdn.magicpatterns.com/uploads/2jzrztghwBLT5wfH6Veasn/image.png'
}, {
  name: 'Minimalist',
  finish: 'Alabaster White',
  image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80&w=800'
}];
export function Showroom() {
  return null;
}